module.exports = __webpack_public_path__ + "static/media/Illus-Bread_1.6d945182.png";